import React from "react";
import {busPickupService} from "../../jwt/_services/eventx/busPickupService";

export const busPickupProvider = {
    getOptions,
    getItem,
};

async function getOptions(fbDataBaseId = null) {
    try {
        const listItems = await busPickupService.search(0,100, {
            fbDataBase : {  id : fbDataBaseId },
            item : { code: null, }
        } );

        return listItems.data.map((itemData) => {
            return (
                {
                    id: itemData.id,
                    value: itemData.code,
                    label: <div><label>{itemData.pickup + ' - ' + itemData.dropOff}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await busPickupService.search(0,10, {
            fbDataBase : {  id : null },
            item : { id: id, }
        } );
        let show = item.pickup && item.dropOff ? item.pickup + '-' + item.dropOff : 'Something went wrong';
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}